import { KommunList } from "types/Kommun.type";
import Dropdown from "./Dropdown";
import { UseFormRegister } from "react-hook-form";
import { useGuessKommun } from "api/postnummer.api";
import { useEffect, useState } from "react";
import { removeWhitespace } from "helpers/string";
import { isValidPostnummer } from "types/transport.type";

type Props = {
  isSetAutomaticallyByPostalCodeEnabled?: boolean;
  postnummer?: string | null;
  name: string;
  register: UseFormRegister<any>;
  setKommunKod: (k: string) => void;
  errorMessage?: string;
};
export const KommunkodDropdown = ({
  isSetAutomaticallyByPostalCodeEnabled = true,
  postnummer,
  name,
  register,
  setKommunKod,
  errorMessage,
}: Props) => {
  const [testedPostnummerList, setTestedPostnummerList] = useState<string[]>(
    [],
  );
  const { mutate, data, isPending } = useGuessKommun();

  useEffect(() => {
    const trimmedPostnummer = removeWhitespace(postnummer ?? "");
    if (
      isSetAutomaticallyByPostalCodeEnabled &&
      isValidPostnummer(trimmedPostnummer) &&
      !testedPostnummerList.some((x) => x === trimmedPostnummer)
    ) {
      setTestedPostnummerList((prev) => [...prev, trimmedPostnummer]);
      mutate({
        postnummer: trimmedPostnummer,
      });
    }
  }, [
    postnummer,
    isSetAutomaticallyByPostalCodeEnabled,
    mutate,
    testedPostnummerList,
  ]);

  useEffect(() => {
    if (data && data.length === 4) {
      setKommunKod(data);
    }
  }, [data, setKommunKod]);

  return (
    <Dropdown
      items={KommunList.map((kommun) => ({
        label: kommun.label,
        value: kommun.code,
      }))}
      label="Kommun"
      name={name}
      register={register}
      //   action={
      //     !postnummer
      //       ? undefined
      //       : () =>
      //           guessKommunMutation.mutate({
      //             postnummer: removeWhitespace(postnummer),
      //           })
      //   }
      actionText="Beräkna från postnummer"
      isActionLoading={isPending}
      descriptionItemText=" "
      disabledOptionValue={""}
      defaultValue=""
      errorMessage={errorMessage}
    />
  );
};
